
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/riviste",
      function () {
        return require("private-next-pages/riviste/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/riviste"])
      });
    }
  